module.exports = __webpack_public_path__ + "static/media/Image-2.1cf5340f.png";